import { Controller } from '@hotwired/stimulus'

// Repopulates a child <select> when a parent <select> changes.
//
// HTML:
//   <form data-controller="dependent-select"
//         data-dependent-select-options-value="{ "1": [{ "value": 10, "label": "A" }], ... }">
//     <select data-dependent-select-target="parent"
//             data-action="change->dependent-select#refresh"></select>
//     <select data-dependent-select-target="child"></select>
//   </form>
export default class extends Controller {
  static targets = ['parent', 'child']
  static values = {
    options: Object,
    placeholder: { type: String, default: "Choose an option" },
    unavailablePlaceholder: { type: String, default: "" }
  }

  connect () {
    this.refresh()
  }

  refresh () {
    const key = this.parentTarget.value
    const options = (this.optionsValue && this.optionsValue[key]) || []
    const previous = this.childTarget.value

    this.childTarget.innerHTML = ''

    const blank = document.createElement('option')
    blank.value = ''
    blank.textContent = options.length === 0 && this.unavailablePlaceholderValue
      ? this.unavailablePlaceholderValue
      : this.placeholderValue
    this.childTarget.appendChild(blank)

    options.forEach((option) => {
      const el = document.createElement('option')
      el.value = option.value
      el.textContent = option.label
      if (String(option.value) === String(previous)) el.selected = true
      this.childTarget.appendChild(el)
    })

    this.childTarget.disabled = options.length === 0
  }
}
